
const adaptBinnacleEntries = binnacle =>
  binnacle.map(entry => {
    return {
      avatar: entry.userData.avatar,
      userName: entry.userData.name,
      note: entry.note,
      addDate: entry.addDate,
      color: entry.substatus ? entry.substatus.color : ''
    }
  })

export {
  adaptBinnacleEntries
}



// WEBPACK FOOTER //
// ./src/pages/RoadSinisters/File/utils.js